import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Card, Spin } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
// import labelConfig from "../../../config/labelConfig";
// import staticConfig from "../../../config/staticConfig";
// import apiConfig from "../../../services/apiConfig";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import tabList from "./components/tabList.json";
import { apiConfig, labelConfig, staticConfig } from "../reports.config";
import DetailScreen from "./components/DetailScreen";
import ParameterScreen from "./components/ParameterScreen";

const ViewCustomReport = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [activeTabKey, setActiveTabKey] = useState("details");
  const [reportDetail, setReportDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    {
      BOM.HasPermission("READ_SAVINGSPRODUCT") && getDetailById(state);
    }
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${apiConfig.Reports}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setReportDetail(objDetail);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  // FLOAT METHODS
  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = "Account Closure";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.DeleteEndOfCircle}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteEndOfCircleMsg);
            navigate("/gla0800");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    details: <DetailScreen reportDetail={reportDetail} />,
    parameters: <ParameterScreen reportDetail={reportDetail} />,
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.customReports}
        pageItems={staticConfig.detailCustomReportsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Card
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginBottom: 50,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCustomReport);
